module.exports = __webpack_public_path__ + "img/partner6.bc6ba533.png";